import React from 'react'
import Header from './Header'
import Services from './Services'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getUserInfoAction } from '../actions/Actions'
import Preloader from '../components/Preloader'
import Footer from '../components/Footer'
import Settings from './Settings'
import NotificationBox from './NotificationBox'
import { DONE, ERROR } from '../Constants'
import { Route, Switch } from 'react-router-dom'
import HeaderMobile from './HeaderMobile'
import { isMobile } from 'react-device-detect';


class Application extends React.Component {

    componentDidMount() {
        this.props.getUserInfo()
    }

    renderBody = () => {
        const { userInfo } = this.props
        switch (userInfo.status) {
            case DONE:
                return (
                    <Switch>
                        <Route exact path='/' component={Services} />
                        <Route path='/settings' component={Settings} />
                    </Switch>
                )
            case ERROR:
                return null
            default:
                return <Preloader />

        }
    };


    render() {
        const { lang } = this.props
        return (<div>
            {isMobile ? <HeaderMobile /> : <Header />}
            <main role="main" className="main">
                <NotificationBox headerHeight={139} />
                {this.renderBody()}
                <Footer lang={lang} />
            </main>
        </div>)
    }

}

export default connect(
    state => ({
        userInfo: state.userInfo,
        lang: state.lang
    }),
    dispatch => ({
        getUserInfo: bindActionCreators(getUserInfoAction, dispatch)
    })
)(Application)